// extracted by mini-css-extract-plugin
export default {"rating":"ay-z","numberOfStars":"by-z","count":"cy-z","barGraphSpacing":"dy-z","barGraph":"ey-z"};